module.exports = __webpack_public_path__ + "img/presentation.646397d4.jpg";